import { render, staticRenderFns } from "./CostOvertimeIndex.vue?vue&type=template&id=fa70dafa&scoped=true&"
import script from "./CostOvertimeIndex.vue?vue&type=script&lang=js&"
export * from "./CostOvertimeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa70dafa",
  null
  
)

export default component.exports